import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// 우리가 앞으로 만들 페이지들을 불러옵니다.
import Home from './Home';
import PartyTest from './PartyTest';
import IdolTest from './IdolTest';
import TransferLoveTest from './TransferLoveTest';

function App() {
  return (
    <Router>
      {/* Routes는 "길들의 목록"입니다. */}
      <Routes>
        {/* 1. 메인 홈 페이지 (도메인 뒤에 아무것도 없을 때) */}
        <Route path="/" element={<Home />} />

        {/* 2. 송년회 테스트 페이지 (주소/party) */}
        <Route path="/party" element={<PartyTest />} />

        {/* 3. 빠순사주 테스트 페이지 (주소/idol) */}
        <Route path="/idol" element={<IdolTest />} />

        {/* 4. 환승연애 테스트 페이지 (주소/transfer) */}
        <Route path="/transfer" element={<TransferLoveTest />} />
      </Routes>
    </Router>
  );
}

export default App;
